module.exports = __webpack_public_path__ + "static/NY-3ba9a7f93a0c87902cae36ab3b28b5e3.svg";